import { graphql } from 'gql';

export const uerPriceListUerRatioRowsCodeFilterGql = graphql(`
    query uerPriceListUerRatioRowsCodeFilter(
        $uerBaseRowId: Long!
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerPriceListUerRatioRowsCodeFilter(uerBaseRowId: $uerBaseRowId, contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);

export const uerPriceListUerRatioRowsNameFilterGql = graphql(`
    query uerPriceListUerRatioRowsNameFilter(
        $uerBaseRowId: Long!
        $contractId: Long!
        $where: FilterValueOfStringFilterInput
    ) {
        uerPriceListUerRatioRowsNameFilter(uerBaseRowId: $uerBaseRowId, contractId: $contractId, where: $where) {
            items {
                value
            }
        }
    }
`);
